import React, { useEffect, useState, useCallback } from 'react';
import AntCondition from '../../utils/AntCondition';
import AntLocalization from '../../utils/AntLocalization';
import AntAPI from '../../utils/AntAPI';
import './index.scss';

function loadCollapsed(key) {
    try { return localStorage.getItem('antHomePanel.' + key) === '1'; } catch (e) { return false; }
}

function saveCollapsed(key, val) {
    try { localStorage.setItem('antHomePanel.' + key, val ? '1' : '0'); } catch (e) {}
}

export default function AntHomeMiniPanel(props) {
    var storageKey = props.storageKey || (props.api ? props.api.module + '_' + props.api.table : 'unknown');
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [collapsed, setCollapsedState] = useState(loadCollapsed(storageKey));

    var visible = AntCondition.isVisible(null, props);

    var load = useCallback(async function () {
        if (!visible) return;
        if (!props.api || !props.api.module || !props.api.table) { setLoading(false); return; }
        setLoading(true);
        try {
            var api = new AntAPI(props.api.module, props.api.table);
            var res = await api.list({
                searchConditions: props.searchConditions || {},
                ordering: props.sortBy || [{ name: 'created_at', type: 'desc' }],
                pageSize: props.pageSize || 5,
                pageIndex: 0
            });
            setItems((res && res.data && res.data.rows) || []);
        } catch (e) {
            setItems([]);
        }
        setLoading(false);
    }, [visible, JSON.stringify(props.api), JSON.stringify(props.searchConditions), JSON.stringify(props.sortBy), props.pageSize]);

    useEffect(() => {
        load();
        var onFocus = function () { if (props.refreshOnFocus !== false) load(); };
        window.addEventListener('focus', onFocus);
        return () => window.removeEventListener('focus', onFocus);
    }, [load, props.refreshOnFocus]);

    function toggle() {
        var next = !collapsed;
        setCollapsedState(next);
        saveCollapsed(storageKey, next);
    }

    if (!visible) return null;

    return (
        <div className={'ant-home-mp' + (collapsed ? ' ant-home-mp--collapsed' : '')}>
            <button type="button" className="ant-home-mp__head" onClick={toggle}>
                {props.icon && <span className={'ant-home-mp__icon dx-icon-' + props.icon}></span>}
                <span className="ant-home-mp__title">{AntLocalization.translateText(props.title)}</span>
                {items.length > 0 && <span className="ant-home-mp__count">{items.length}</span>}
                <span className={'ant-home-mp__chevron dx-icon-' + (collapsed ? 'chevrondown' : 'chevronup')}></span>
            </button>
            {!collapsed && (
                <div className="ant-home-mp__body">
                    {loading && <div className="ant-home-mp__loading">…</div>}
                    {!loading && items.length === 0 && (
                        <div className="ant-home-mp__empty">
                            {AntLocalization.translateText(props.emptyText || { vi: 'Không có dữ liệu', en: 'No data', fr: 'Aucune donnée', es: 'Sin datos', id: 'Tidak ada data', ja: 'データなし', zh: '暂无数据', ko: '데이터 없음', hi: 'कोई डेटा नहीं', ar: 'لا توجد بيانات' })}
                        </div>
                    )}
                    {!loading && items.length > 0 && (
                        <div className="ant-home-mp__list">
                            {items.map(function (it, i) {
                                return (
                                    <div key={it.id || i} className="ant-home-mp__item">
                                        {props.itemRender ? props.itemRender(it) : (
                                            <>
                                                <div className="ant-home-mp__item-title">{it.title || it.name || it.code}</div>
                                                {it.description && <div className="ant-home-mp__item-desc">{it.description}</div>}
                                            </>
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}
